// Config store — language preference, audit setup config, theme
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
const initialConfig = { company:"", cnpj:"", scope:"", auditor:"", team:"", locations:"", criteria:"", auditType:"3p", norms:["9001","14001","45001"] };

export const useConfigStore = create(persist(
  (set) => ({
    lang: "pt",
    setLang: (lang) => set({ lang }),
    config: null,
    setConfig: (config) => set({ config }),
    initialConfig,
  }),
  {
    name: "norm_config_store",
    storage: createJSONStorage(() => localStorage),
    partialize: (state) => ({ lang: state.lang, config: state.config }),
  }
));
